import { SxProps, Theme } from '@mui/material';

import { WindowSize } from 'hooks/useResize';

import { FOOTER_HEIGHT } from './model';

type DrawCursor = 'crosshair' | 'grab';

const DRAW_CONTAINER_SX: SxProps<Theme> = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: `${FOOTER_HEIGHT}px`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export function getDrawContainerSx(
  _dimensions: WindowSize,
  cursor: DrawCursor
): SxProps<Theme> {
  return {
    ...DRAW_CONTAINER_SX,
    cursor,
  };
}

export const DRAW_FOOTER_SX: SxProps<Theme> = {
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  zIndex: 21,
  backgroundColor: 'white',
  display: 'flex',
  width: '100%',
  height: `${FOOTER_HEIGHT}px`,
  justifyContent: 'space-between',
  alignContent: 'center',
  '& > *': {
    margin: '8px',
  },
};

export const DRAW_BUTTONS_SX: SxProps<Theme> = (theme) => ({
  position: 'absolute',
  display: 'flex',
  flexDirection: 'column',
  width: '48px',
  right: '26px',
  bottom: `${FOOTER_HEIGHT + 26}px`,
  zIndex: 20,
  '& > *': {
    borderRadius: '50%',
    marginTop: '11px',
  },
  '& > .toggle .MuiButtonBase-root': {
    background: '#FFFFFF',
    borderRadius: '50%',
    '&.active': {
      background: theme.palette.primary.main,
      '& svg': {
        fill: theme.palette.primary.contrastText,
      },
    },
  },
  '& > .button': {
    background: '#FFFFFF',
    '& .MuiSvgIcon-root': {
      fill: '#000000',
    },
    '& .MuiIconButton-label svg': {
      fill: '#000000',
    },
  },
});
